import React, {FC} from 'react';

import styles from './AppLoader.module.scss';
import AppLoaderContent from './AppLoaderContent';

const AppLoadeRaw: FC = () => {
    return (
        <div className={styles.Overlay}>
            <div className={styles.AppLoaderContainer}>
                <AppLoaderContent loaderText='' />
            </div>
        </div>
    );
};

export default AppLoadeRaw;
